// @flow strict
import React from 'react';

import { Grid, Button } from '@material-ui/core';

import { useLanguageContext } from '~contexts/language-context';

import { NewsletterSignupIcon } from './newsletter-signup-icon';

import * as styles from './newsletter-signup.module.less';

const mailChimpMailingLists = {
  de: 'https://omq.us18.list-manage.com/subscribe?u=f843c42122fe1ecd9121296a0&id=aec1bf23e3',
  en: 'https://omq.us18.list-manage.com/subscribe?u=f843c42122fe1ecd9121296a0&id=d691c68d19',
};

/**
 * Component to sign up for mail chimp newsletter.
 *
 * @returns {Node}
 */
export const NewsletterSignup = () => {

  const { language, loc } = useLanguageContext();

  return (
    <section id="newsletter-signup" className={styles.newsletterSignup}>
      <Grid container spacing={6} justifyContent="space-evenly">
        {/* Newsletter icon */}
        <Grid item xs={12} md={2}>
          <div className={styles.iconWrapper}>
            <NewsletterSignupIcon />
          </div>
        </Grid>

        {/* Newsletter form */}
        <Grid item xs={12} md={8}>
          <h3 className={styles.title}>{loc('_newsletter_title')}</h3>
          <p className={styles.description}>{loc('_newsletter_description')}</p>
          <Button
              variant="contained"
              color="primary"
              size="large"
              classes={{
                root: styles.signupButton,
              }}
              href={mailChimpMailingLists[language]}
              target="_blank"
          >
            {loc('_newsletter_submit')}
          </Button>
        </Grid>
      </Grid>
    </section>
  );
};
